import { jsx as _jsx } from "react/jsx-runtime";
import { UpdateDeliveryModal_ContentComponent } from "../ModalContent/UpdateDeliveryModal_ContentComponent";
import { ContactUs } from "../SharedComponents/ContactUs";
/**
 * A small abstraction to make the component more readable.
 */
export const DialogContentComponent = (props) => {
    // If we aren't showing addresses, display the contact us component.
    if (!props.loading && !props.showAddresses)
        return _jsx(ContactUs, {});
    // Otherwise, display the modal content.
    return _jsx(UpdateDeliveryModal_ContentComponent, Object.assign({}, props));
};
